// src/js/config/ui/toggleConfigTableVisibility.js
import { DOMElements } from '../dom.js';
import { updateDynamicBreakpoint } from '../../utils/helpers.js';

export function toggleConfigTableVisibility() {
    const { showBtn, showConfigurationTable } = DOMElements;
    if (!showBtn || !showConfigurationTable) return;

    const strings = window.SimP_Strings || {};
    const hideText = strings.hide_configuration || 'Hide configuration';
    const showText = strings.show_configuration || 'Show configuration';

    const isVisible = showConfigurationTable.classList.toggle('is-visible');
    showBtn.textContent = isVisible ? hideText : showText;
    updateDynamicBreakpoint();
}